module.exports = __webpack_public_path__ + "static/cp-product-737cdcb28e074e761f6df11fd673f0bd.png";